import React from "react";
import { Group } from "../../graphql/types";

import {
  Link,
  Badge
} from "../wombat-ui";

import { getGroupColor } from "../../utils/colors";

type GroupBadgeProps = {
  group: Group
};

const GroupBadge: React.FC<GroupBadgeProps> = ({ group }) => {
  return (
    <Link to={`/users?groupId=${group.id}`} id={`user_group_${group.id}`}>
      <Badge variant={getGroupColor(group?.type)}>
        {group.name}
      </Badge>
    </Link>
  );
}

export default GroupBadge;

